export const GET_MATCH_INFO = 'GET_MATCH_INFO';
export const SET_MATCH_PLAYERS = "SET_MATCH_PLAYERS";